var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-list.ts
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ChemistryLitElement } from "../../chemistry-lit-element.js";
import { css } from "../../directives/css.js";
import { xComponents } from "../x-components.js";
import "./x-flex.js";
import "./x-icon.js";
var XList = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.divided = true;
    this.styles = () => [
      { ":host": { "::slotted(*:not(:last-of-type))": { borderBottom: `1px solid ${this.colors.neutral.shade(50)}` } } }
    ];
  }
  render() {
    return html`
      <x-flex>
        <slot></slot>
      </x-flex>
    `;
  }
};
__decorateClass([
  property({ type: Boolean })
], XList.prototype, "divided", 2);
XList = __decorateClass([
  customElement("x-list")
], XList);
var XListItem = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.active = false;
    this.success = false;
    this.icon = "";
  }
  render() {
    return xComponents(html`
      <x-flex
        ${css({
      width: "100%",
      backgroundColor: this.active ? this.colors.accent : this.success ? this.colors.tone.success : "transparent",
      color: this.active ? this.colors.on.accent : this.success ? this.colors.on.tone.success : this.colors.black,
      position: "relative",
      padding: `${this.spacing.sm} 0`
    })}
        space-between
        space="xxs"
        horizontal
        crossaxis-center
      >
        <x-flex horizontal crossaxis-center space="sm">
          ${this.icon || this.success ? html` <x-icon> ${this.success ? "check" : this.icon} </x-icon> ` : nothing}
          <slot></slot>
        </x-flex>

        ${this._helperIcons()}
      </x-flex>
    `);
  }
  _helperIcons() {
    return html`
      <x-flex horizontal space="xs">
        <slot name="helper-icons"></slot>
      </x-flex>
    `;
  }
};
__decorateClass([
  property({ type: Boolean })
], XListItem.prototype, "active", 2);
__decorateClass([
  property({ type: Boolean })
], XListItem.prototype, "success", 2);
__decorateClass([
  property()
], XListItem.prototype, "icon", 2);
XListItem = __decorateClass([
  customElement("x-list-item")
], XListItem);
export {
  XList,
  XListItem
};
